import { Label, SelectItem } from "@fronterahealth/frontera-ui-components";

// Data collection type options for select
import { ProgressType } from "@api/graphql/types-and-hooks";
import { InlineEditField } from "@components/ProgrammingReview/InlineEditField";
import { useInlineGoalEdit } from "@components/ProgrammingReview/hooks/useInlineEdit";
import { useProgrammingReviewData } from "@providers/ProgrammingReviewProvider";

const DATA_COLLECTION_OPTIONS: SelectItem[] = [
  { id: ProgressType.Duration, primary: "Duration" },
  { id: ProgressType.Frequency, primary: "Frequency" },
  { id: ProgressType.Interval, primary: "Interval" },
  { id: ProgressType.Rate, primary: "Rate" },
  { id: ProgressType.Scale, primary: "Scale" },
  { id: ProgressType.TaskAnalysis, primary: "Task Analysis" },
  { id: ProgressType.Trial, primary: "Trial" },
];

interface ProgrammingReviewTargetFormProps {
  isReadOnly?: boolean;
}

export const ProgrammingReviewTargetForm: React.FC<ProgrammingReviewTargetFormProps> = ({ isReadOnly = false }) => {
  const { selectedProgramReviewTarget } = useProgrammingReviewData();
  const { saveTargetFields } = useInlineGoalEdit({
    targetId: selectedProgramReviewTarget?.id || "",
  });
  return (
    <div
      key={selectedProgramReviewTarget?.id || "no-target"}
      className="flex border border-limestone-200 rounded-2xl flex-col bg-white w-full"
    >
      <div className="flex items-center justify-between  p-4 px-6 rounded-t-2xl cursor-pointer border-b border-limestone-100 ">
        <div className="flex items-center gap-2 flex-1">
          <Label size="medium" colorType="primary" displayType="loud">
            Target Details
          </Label>
        </div>
      </div>
      <div className="p-6 flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <InlineEditField
            key="target-title"
            value={selectedProgramReviewTarget?.title || ""}
            fieldKey="title"
            onSave={saveTargetFields}
            title="Name"
            isReadOnly={isReadOnly}
            required
          />
        </div>

        <div className="flex flex-col gap-2">
          <InlineEditField
            key="target-description"
            value={selectedProgramReviewTarget?.description || ""}
            fieldKey="description"
            onSave={saveTargetFields}
            title="Description"
            isReadOnly={isReadOnly}
          />
        </div>

        <div className="flex flex-col gap-2">
          <InlineEditField
            key="target-type"
            fieldKey="type"
            onSave={saveTargetFields}
            title="Data Collection Type"
            inputType="select"
            selectOptions={DATA_COLLECTION_OPTIONS}
            value={selectedProgramReviewTarget?.type || ""}
            isReadOnly={isReadOnly}
          />
        </div>
      </div>
    </div>
  );
};
